// import { Row, Col } from "reactstrap";
import { getVideo, deleteVideo, addVideo } from "store/auth/profile/profileSlice";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Button, message, Form, Upload, Row, Col, Card, Modal } from "antd";
import { DeleteOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { BASE_URL } from "helpers/api_helper";
export const Video = () => {
  const dispatch = useDispatch();
  const videos = useSelector((state) => state.Profile.videos);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]); // State to manage the file list

  useEffect(() => {
    dispatch(getVideo());
  }, [dispatch]);

  // Function to convert file path to usable URL
  const getVideoUrl = (filePath) => {
    if (!filePath) return '';
    const filename = filePath.split('\\').pop();
    const url = `${BASE_URL}/${filename}`;
    if (!url?.includes("/uploads/")) {
      return `${BASE_URL}/uploads/${filename}`;
    }
    return url;
  };

  const handleDelete = async (id) => {
    try {
      const response = await dispatch(deleteVideo(id));
      if (response.status === 200) {
      } else {
        // message.error('Error deleting video');
      }
      message.success('Video deleted successfully');
      dispatch(getVideo());
    } catch (error) {
      message.error(error.message);
    }
  };

  const handleaddVideos = async () => {
    const videoFile = fileList[0]?.originFileObj; // Get the file from the fileList state

    if (!videoFile) {
      message.error('Please select a video');
      return;
    }

    const formData = new FormData();
    formData.append('video', videoFile);

    try {
      const response = await dispatch(addVideo(formData));
      console.log(response);
      message.success('Video uploaded successfully');
      setFileList([]); // Clear the file list after successful upload
      dispatch(getVideo()); // Refresh the video list
    } catch (error) {
      console.log(error);
      message.error('Failed to upload video');
    }
  };

  // Handle file change in the Upload component
  const handleFileChange = ({ fileList }) => {
    setFileList(fileList); // Update the fileList state
    form.setFieldsValue({ video: fileList }); // Update the form state
  };
  const [previewSrc, setPreviewSrc] = useState(null);

  return (
    <>
      <div className="py-4">
        <div className="
            container
            bg-light
            rounded-3
            shadow-sm
            p-3 p-sm-4 p-md-5
            mx-auto
          "
        >
          <Row className="g-4">
            {videos?.map(video => (
              <Col
                key={video._id}
                xs={24}
                sm={12}
                md={8}
                className="d-flex"
              >
                <Card className="w-100 d-flex flex-column justify-content-between">
                  <div className="ratio ratio-16x9 mb-2">
                    <video
                      muted
                      className="w-100 h-100"
                      style={{ objectFit: 'cover' }}
                    >
                      <source src={getVideoUrl(video.url)} type="video/mp4" />
                    </video>
                  </div>
                  <div className="d-flex justify-content-between align-items-center small mb-2">
                    <Button
                      type="default"
                      icon={<EyeOutlined />}
                      size="small"
                      onClick={() => setPreviewSrc(getVideoUrl(video.url))}
                    >
                      Visualiser
                    </Button>
                    <Button
                      type="text"
                      icon={<DeleteOutlined />}
                      size="small"
                      onClick={() => handleDelete(video._id)}
                    />
                  </div>
                  <p className="text-end text-muted small mb-0">
                    {new Date(video.createdAt).toLocaleDateString()}
                  </p>
                </Card>
              </Col>
            ))}
          </Row>

          <Form form={form} style={{ marginTop: "50px" }}>
            <Form.Item name="video" rules={[{ required: true, message: 'Please upload a video' }]}>
              <div className="d-flex gap-3 align-items-center">
                <Upload
                  accept="video/*"
                  fileList={fileList} // Controlled file list
                  beforeUpload={() => false} // Prevent automatic upload
                  onChange={handleFileChange} // Handle file change
                >
                  <Button style={{ backgroundColor: '#157088', padding: "30px", color: 'white' }}>
                    Ajouter une vidéo
                  </Button>
                </Upload>

              </div>
              <Button
                onClick={handleaddVideos}
                style={{ backgroundColor: '#157088', padding: "10px" }}
                icon={<PlusOutlined />}
              ></Button>
            </Form.Item>

          </Form>
        </div>
      </div>

      {/* Modal de preview */}
      <Modal
        open={!!previewSrc}
        onCancel={() => setPreviewSrc(null)}
        footer={null}
        width="80%"
        getContainer={() => document.body}
        styles={{ mask: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      // modalRender={modalContent => (
      //   <div
      //     style={{
      //       display: 'flex',
      //       alignItems: 'center',
      //       justifyContent: 'center',
      //       minHeight: '100vh',
      //       padding: 0,
      //     }}
      //   >
      //     {modalContent}
      //   </div>
      // )}
      >
        {previewSrc && (
          <div
            key={previewSrc}
            style={{ backgroundColor: '#000', padding: 0 }}
          >
            <video
              key={previewSrc}
              controls
              autoPlay
              style={{
                display: 'block',
                width: '100%',
                maxHeight: '80vh',
                objectFit: 'contain',
              }}
            >
              <source src={previewSrc} type="video/mp4" />
            </video>
          </div>
        )}

      </Modal>

    </>
  );
};

export default Video;